
import { AlignLeft, DollarSign, Download, Globe, Image as ImageIcon, Link as LinkIcon, ListFilter, Loader2, MonitorPlay, Search, Tag } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient'; 
import { styles } from '../../styles'; 

export function MoviePublisher() {
  const [videoUrl, setVideoUrl] = useState(''); 
  const [fullVideoUrl, setFullVideoUrl] = useState('');
  const [bannerUrl, setBannerUrl] = useState('');
  const [thumbFile, setThumbFile] = useState<File | null>(null);
  const [thumbUrl, setThumbUrl] = useState(''); 
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('oculto');
  const [productLink, setProductLink] = useState('');
  const [downloadLink, setDownloadLink] = useState('');
  const [tags, setTags] = useState('');
  const [plataforma, setPlataforma] = useState('Disponível Agora');
  const [tmdbId, setTmdbId] = useState(''); // 👈 NOVO: Guarda o ID do TMDB

  const [loading, setLoading] = useState(false);
  const [previewThumb, setPreviewThumb] = useState('');
  const [tmdbSearchQuery, setTmdbSearchQuery] = useState(''); // 👈 NOVO: Input de busca da API
  const [searchingTmdb, setSearchingTmdb] = useState(false); // 👈 NOVO: Load da busca

  const [audioType, setAudioType] = useState('DUBLADO'); // 👈 NOVO: Estado do tipo de áudio

  const [aspectMode, setAspectMode] = useState<'16:9' | '2:3'>('16:9');

  // 🎬 BUSCA AUTOMÁTICA NO TMDB
  // 🎬 BUSCA AUTOMÁTICA NO TMDB COM TRAILER 
  // 🎬 BUSCA AUTOMÁTICA NO TMDB COM DATA DO BRASIL E TRAILER 
  const handleTmdbSearch = async () => {
    if (!tmdbSearchQuery) return alert("Digite o nome do filme ou série para buscar!");
    setSearchingTmdb(true);
    
    const TMDB_API_KEY = "bd94a1b0354e2306b60de4a33422910e"; 

    try {
      // 1. Busca os dados principais do Filme/Série
      const response = await fetch(`https://api.themoviedb.org/3/search/multi?api_key=${TMDB_API_KEY}&language=pt-BR&query=${encodeURIComponent(tmdbSearchQuery)}`);
      const data = await response.json();

      if (!data.results || data.results.length === 0) {
        throw new Error("Nenhum resultado encontrado no TMDB para esse nome.");
      }

      const item = data.results[0];
      const mediaType = item.media_type || 'movie';
      const itemId = item.id;

      // 2. Busca os detalhes completos unificados (Incluindo as datas por país e trailers) em uma chamada só
      let releaseDateToSave = item.release_date || item.first_air_date || '';
      let trailerKey = '';

      try {
        const detailsRes = await fetch(`https://api.themoviedb.org/3/${mediaType}/${itemId}?api_key=${TMDB_API_KEY}&language=pt-BR&append_to_response=release_dates,videos`);
        const detailsData = await detailsRes.json();

        // Pega a data exata de lançamento para o Brasil (BR) ordenada cronologicamente
        if (detailsData.release_dates && detailsData.release_dates.results) {
          const brObj = detailsData.release_dates.results.find((r: any) => r.iso_3166_1 === 'BR');
          if (brObj && brObj.release_dates && brObj.release_dates.length > 0) {
            const sortedDates = brObj.release_dates.sort((a: any, b: any) => new Date(a.release_date).getTime() - new Date(b.release_date).getTime());
            if (sortedDates[0].release_date) {
              releaseDateToSave = sortedDates[0].release_date;
            }
          }
        }

        // Tenta achar o trailer em PT-BR ou Inglês
        const vList = detailsData.videos?.results || [];
        let trailer = vList.find((v: any) => v.type === 'Trailer' && v.site === 'YouTube');
        if (!trailer) {
          // Fallback para ingles se nao achar em pt
          const enRes = await fetch(`https://api.themoviedb.org/3/${mediaType}/${itemId}/videos?api_key=${TMDB_API_KEY}`);
          const enData = await enRes.json();
          trailer = enData.results?.find((v: any) => v.type === 'Trailer' && v.site === 'YouTube');
        }

        if (trailer) {
          trailerKey = `https://www.youtube.com/watch?v=${trailer.key}`;
        }
      } catch (detErr) {
        console.log("Erro ao buscar detalhes avançados:", detErr);
      }

      const nomeOficial = item.title || item.name || tmdbSearchQuery;
      const sinopseOficial = item.overview || "";
      const posterPath = item.poster_path ? `https://image.tmdb.org/t/p/w500${item.poster_path}` : "";
      const backdropPath = item.backdrop_path ? `https://image.tmdb.org/t/p/original${item.backdrop_path}` : "";

      // Preenche os campos do formulário
      setTitle(nomeOficial);
      setDescription(sinopseOficial);
      if (posterPath) {
        setThumbUrl(posterPath);
        setPreviewThumb(posterPath); 
      }
      if (backdropPath) setBannerUrl(backdropPath);
      setTmdbId(itemId.toString());
      setVideoUrl(trailerKey);

      // Se a data do Brasil veio, podemos opcionalmente ajustar se houver campo de data no state, 
      // mas o importante é que o tmdbId agora está perfeitamente vinculado e a data correta será lida pelo player.
      alert(`✨ SUCESSO! Dados, Trailer e Data do Brasil puxados para: "${nomeOficial}"`);
    } catch (err: any) {
      alert("Erro ao buscar no TMDB: " + err.message);
    } finally {
      setSearchingTmdb(false);
    }
  };

  // 🪄 IA GEMINI
  const handleGeminiMagic = async () => {
    if (!title) return alert("Digite o assunto primeiro!");
    setLoading(true);
    const API_KEY = process.env.REACT_APP_GEMINI_API_KEY;
    
    try {
      const URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-pro:generateContent?key=${API_KEY}`;
      const response = await fetch(URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          contents: [{ parts: [{ text: `Gere um JSON para o assunto "${title}". Categorias: tecnologia:ia, podcast, filmes:acao. Formato: {"novoTitulo": "", "sinopse": "", "tags": "", "categoria": ""}` }] }]
        })
      });

      const result = await response.json();
      if (result.error) throw new Error(result.error.message);

      const text = result.candidates[0].content.parts[0].text;
      const jsonMatch = text.match(/\{[\s\S]*\}/);
      
      if (jsonMatch) {
        const data = JSON.parse(jsonMatch[0]);
        setTitle(data.novoTitulo);
        setDescription(data.sinopse);
        setTags(data.tags);
        setCategory(data.categoria || "");
      }
    } catch (err: any) {
      alert("IA diz: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // 🖼️ LÓGICA DE PRÉVIA
  useEffect(() => {
    const extrairIdUniversal = (url: string) => {
      if (!url) return null;
      const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
      const match = url.match(ytRegex);
      if (match && match[1]) return match[1];
      try {
        if (url.includes('youtube.com/watch')) {
          const urlObj = new URL(url);
          const videoId = urlObj.searchParams.get('v');
          if (videoId && videoId.length === 11) return videoId;
        }
      } catch (e) {}
      return null;
    };

    if (thumbFile) {
      const url = URL.createObjectURL(thumbFile);
      setPreviewThumb(url);
      return () => URL.revokeObjectURL(url);
    } else if (thumbUrl) {
      setPreviewThumb(thumbUrl);
    } else {
      const idCurto = extrairIdUniversal(videoUrl);
      const idLongo = extrairIdUniversal(fullVideoUrl);
      const idFinal = idCurto || idLongo;

      if (idFinal) setPreviewThumb(`https://img.youtube.com/vi/${idFinal}/maxresdefault.jpg`);
      else setPreviewThumb('');
    }
  }, [thumbFile, thumbUrl, videoUrl, fullVideoUrl]);

  // 🚀 LÓGICA DE PUBLICAÇÃO (Com o tmdb_id integrado)
  const handlePublishSearch = async () => {
    if (!title) return alert("Digite pelo menos o Título!");
    setLoading(true);

    const extrairIdYoutube = (url: string) => {
      if (!url) return null;
      const ytRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/;
      const match = url.match(ytRegex);
      if (match && match[1]) return match[1];
      return null;
    };

   try {
     let finalThumbUrl = '';
     const embedId = extrairIdYoutube(videoUrl);
     const fullEmbedId = extrairIdYoutube(fullVideoUrl);

     if (thumbFile) {
       const fileExt = thumbFile.name.split('.').pop();
       const fileName = `${Date.now()}_${Math.random().toString(36).substring(2)}.${fileExt}`;
       
       const { error: uploadError } = await supabase.storage
         .from('videos_feed')
         .upload(fileName, thumbFile);

       if (uploadError) {
         throw new Error("Erro no upload da imagem: " + uploadError.message);
       }

       const { data } = supabase.storage
         .from('videos_feed')
         .getPublicUrl(fileName);

       finalThumbUrl = data.publicUrl;
     } else if (thumbUrl) {
       finalThumbUrl = thumbUrl;
     } else if (embedId) {
       finalThumbUrl = `https://img.youtube.com/vi/${embedId}/maxresdefault.jpg`;
     } else {
       finalThumbUrl = previewThumb;
     }

     const { error: dbError } = await supabase.from('videos').insert([{
        title, 
        description, 
        url: videoUrl, 
        thumbnail: finalThumbUrl,
        banner: bannerUrl,
        embed_id: embedId,
        full_video_id: fullEmbedId,
        category, 
        product_link: productLink, 
        download_link: downloadLink,
        plataforma: plataforma,
        post_type: 'search', 
        tags: tags.toLowerCase(),
        likes_count: 0, 
        comments_count: 0, 
        views_count: 0,
        is_ad: false,
        is_short: false,
        tmdb_id: tmdbId || null,
        audio_type: audioType
      }]);

     if (dbError) throw dbError;
     
     alert(`✅ SUCESSO! Publicado com ID do TMDB: ${tmdbId || 'Nenhum'}`);
     setVideoUrl(''); setFullVideoUrl(''); setBannerUrl(''); setThumbUrl(''); 
     setThumbFile(null); setTitle(''); setDescription(''); setDownloadLink(''); 
     setProductLink(''); setTags(''); setTmdbId(''); setTmdbSearchQuery('');
   } catch (err: any) {
     alert("Erro: " + err.message);
   } finally {
     setLoading(false);
   }
  };

  return (
    <div>
      <style>{`
        .movie-publisher-layout {
          display: grid;
          grid-template-columns: 1fr 380px;
          gap: 30px;
          width: 100%;
          box-sizing: border-box;
        }
        .movie-form-inner {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }
        @media (max-width: 768px) {
          .movie-publisher-layout {
            display: flex;
            flex-direction: column-reverse;
            gap: 15px;
          }
          .movie-form-inner {
            display: flex;
            flex-direction: column;
            gap: 15px;
          }
        }
      `}</style>

      <div className="movie-publisher-layout">
        <div style={styles.formCard}>
          <h2 style={{ color: '#ff0000', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 10, fontSize: '18px' }}>
            <MonitorPlay size={22} /> Publicar no Assistir + TMDB
          </h2>

          {/* 🔍 BARRA DE BUSCA RÁPIDA TMDB */}
          <div style={{ backgroundColor: '#1a1a1a', padding: 15, borderRadius: 8, marginBottom: 20, border: '1px solid #333' }}>
            <label style={{ ...styles.label, color: '#3b82f6', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
              <Search size={14} /> Buscar Metadados Automáticos (TMDB)
            </label>
            <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
              <input 
                style={{ ...styles.input, flex: 1 }} 
                value={tmdbSearchQuery} 
                onChange={e => setTmdbSearchQuery(e.target.value)} 
                placeholder="Ex: Homem-Aranha, Matrix..." 
              />
              <button 
                type="button" 
                onClick={handleTmdbSearch} 
                disabled={searchingTmdb}
                style={{ backgroundColor: '#2563eb', color: '#fff', border: 'none', borderRadius: 4, padding: '0 15px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 }}
              >
                {searchingTmdb ? <Loader2 className="animate-spin" size={16} /> : 'Puxar do TMDB'}
              </button>
            </div>
            
            {/* 👇 NOVO: Input manual para o TMDB ID caso queira colar direto */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ color: '#888', fontSize: '11px' }}>TMDB ID:</span>
              <input 
                style={{ ...styles.input, padding: '4px 8px', fontSize: '12px', width: '120px' }} 
                value={tmdbId} 
                onChange={e => setTmdbId(e.target.value)} 
                placeholder="Ex: 550" 
              />
              {tmdbId && <span style={{ color: '#22c55e', fontSize: 11 }}>✔️ Vinculado</span>}
            </div>
          </div>

          <div className="movie-form-inner">
            {/* COLUNA ESQUERDA */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              
              <div style={styles.inputGroup}>
                <label style={styles.label}><LinkIcon size={14}/> Link do Trailer (Curto)</label>
                <input style={styles.input} value={videoUrl} onChange={e => setVideoUrl(e.target.value)} placeholder="YouTube ou MP4" />
              </div>

              <div style={styles.inputGroup}>
                <label style={{...styles.label, color: '#ff0000'}}><MonitorPlay size={14}/> Link do FILME COMPLETO</label>
                <input style={{...styles.input, borderColor: '#ff0000'}} value={fullVideoUrl} onChange={e => setFullVideoUrl(e.target.value)} placeholder="Link do YouTube completo" />
              </div>

              <div style={styles.inputGroup}>
                <label style={{...styles.label, color: '#00ccff'}}><ImageIcon size={14}/> Banner (Séries/Canais - 16:9)</label>
                <input style={{...styles.input, borderColor: '#00ccff'}} value={bannerUrl} onChange={e => setBannerUrl(e.target.value)} placeholder="Link da imagem horizontal..." />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}><ImageIcon size={14}/> Capa Vertical (Upload ou Link)</label>
                <input type="file" accept="image/*" onChange={e => setThumbFile(e.target.files?.[0] || null)} style={{...styles.input, marginBottom: 5}} />
                <input style={styles.input} value={thumbUrl} onChange={e => setThumbUrl(e.target.value)} placeholder="Ou cole o link da capa..." />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}><Tag size={14}/> Tags de Busca</label>
                <input style={styles.input} value={tags} onChange={e => setTags(e.target.value)} placeholder="acao, terror, games..." />
              </div>
            </div>

            {/* COLUNA DIREITA */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={styles.inputGroup}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <label style={styles.label}>Título</label>
                  <button type="button" onClick={handleGeminiMagic} style={{ backgroundColor: '#6200ee', color: '#fff', border: 'none', borderRadius: 4, padding: '2px 8px', fontSize: 10, cursor: 'pointer' }}>
                    🪄 IA GEMINI
                  </button>
                </div>
                <input style={styles.input} value={title} onChange={e => setTitle(e.target.value)} placeholder="Título da Obra..." />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}><ListFilter size={14}/> Categorias do Catálogo</label>
                <select style={styles.input} value={category} onChange={e => setCategory(e.target.value)}>
                  <option value="oculto">👁️ Invisível (Só Pesquisa)</option>
                  
                  <optgroup label="🔥 DESTAQUES E EXPLORE">
                    <option value="curiosidades">💡 Curiosidades</option>
                    <option value="celebridade">⭐ Celebridades</option>
                    <option value="top10">🔝 Top 10</option>
                    <option value="top5">⚡ Top 5</option>
                    <option value="novidades">🆕 Novidades</option>
                    <option value="viral">🔥 Vídeos Virais</option>
                  </optgroup>
                  
                  <optgroup label="🚀 NOVIDADES DA COMUNIDADE">
                    <option value="ao_vivo">🔴 Ao Vivo & Resenha</option>
                    <option value="votacao">🏆 Votação da Galera</option>
                    <option value="documentario">🍿 Mistérios & Documentários</option>
                    <option value="canais">📺 Canais dos Crias</option>
                  </optgroup>

                  <optgroup label="✨ DIVERSÃO">
                    <option value="tecnologia:ia">🤖 I.A(I.A)</option>
                    <option value="podcast">🎙️ Podcast</option>
                    <option value="desenho">🎨 Desenhos</option>
                    <option value="nostalgia">🎞️ Nostalgia</option>
                    <option value="outros">Outros</option>
                  </optgroup>

                  <optgroup label="🎬 CINEMA & TV">
                    <option value="filmes:aventura">Aventura</option>
                    <option value="filmes:terror">Terror & Suspense</option>
                    <option value="filmes:acao">Ação</option>
                    <option value="filmes:ficcao">Ficção Científica</option>
                    <option value="filmes:nacional">🇧🇷 Filmes Brasileiros</option>
                    <option value="dorama">🇰🇷 Doramas</option>
                    <option value="filmes:comedia">Comédia</option>
                    <option value="filmes:trailer_cena">🎬 Trailers & Cenas</option>
                    <option value="serie">Série</option>
                    <option value="novela">Novela</option>
                  </optgroup>

                  <optgroup label="⚽ VIDA & ESPORTE">
                    <option value="esporte">Esporte</option>
                  </optgroup>

                  <optgroup label="🎮 MUNDO GAME">
                    <option value="games">Geral / Todos</option>
                    <option value="games:acao">Ação</option>
                    <option value="games:aventura">Aventura</option>
                    <option value="games:terror">Terror</option>
                    <option value="games:rpg">RPG</option>
                    <option value="games:esporte">Esporte</option>
                    <option value="games:playstation">PlayStation</option>
                    <option value="games:xbox">Xbox</option>
                    <option value="games:nintendo">Nintendo</option>
                    <option value="games:pc">PC Gamer</option>
                  </optgroup>

                  <optgroup label="🔥 DESTAQUES">
                    <option value="lancamento">Lançamento</option>
                    <option value="novidades:mais-visto">Mais Visto</option>
                  </optgroup>
                </select>
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}><Globe size={16} color="#00ccff"/> Onde está disponível?</label>
                <input placeholder="Ex: Netflix, Cinema..." style={styles.input} value={plataforma} onChange={(e) => setPlataforma(e.target.value)} />
              </div>

              <div style={styles.inputGroup}>
                <label style={{...styles.label, color: '#e50914'}}>🎙️ Tipo de Áudio</label>
                <select style={styles.input} value={audioType} onChange={e => setAudioType(e.target.value)}>
                  <option value="DUBLADO">Dublado</option>
                  <option value="LEGENDADO">Legendado</option>
                </select>
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}><Download size={14}/> Link de Download</label>
                <input style={styles.input} value={downloadLink} onChange={e => setDownloadLink(e.target.value)} placeholder="Mega, Drive..." />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}><DollarSign size={14}/> Link de Afiliado</label>
                <input style={styles.input} value={productLink} onChange={e => setProductLink(e.target.value)} placeholder="Produto relacionado..." />
              </div>
            </div>
          </div>

          <div style={{ ...styles.inputGroup, marginTop: 15 }}>
            <label style={styles.label}><AlignLeft size={14}/> Sinopse</label>
            <textarea style={{...styles.input, height: 60, resize: 'none'}} value={description} onChange={e => setDescription(e.target.value)} />
          </div>

          <button type="button" onClick={handlePublishSearch} disabled={loading} style={{...styles.btnPublish, marginTop: 20, backgroundColor: '#ff0000', color: '#fff', width: '100%'}}>
            {loading ? <Loader2 className="animate-spin" /> : 'PUBLICAR EM ASSISTIR'}
          </button>
        </div>

       {/* PRÉVIA */}
        <aside style={{ backgroundColor: '#111', padding: 20, borderRadius: 20, border: '1px solid #222', textAlign: 'center', height: 'fit-content' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
            <h3 style={{ color: '#fff', fontSize: 14, margin: 0 }}>PRÉVIA: {aspectMode}</h3>
            <button 
              type="button" 
              onClick={() => setAspectMode(aspectMode === '16:9' ? '2:3' : '16:9')}
              style={{ backgroundColor: '#222', color: '#00ccff', border: '1px solid #00ccff', borderRadius: 4, padding: '3px 8px', fontSize: 10, cursor: 'pointer', fontWeight: 'bold' }}
            >
              🔄 Alternar {aspectMode === '16:9' ? '2:3' : '16:9'}
            </button>
          </div>

          <div style={{ 
            width: aspectMode === '16:9' ? '280px' : '180px', 
            height: aspectMode === '16:9' ? '157.5px' : '270px', 
            backgroundColor: '#000', margin: '0 auto', borderRadius: 10, border: '2px solid #333', overflow: 'hidden', position: 'relative', transition: 'all 0.3s ease' 
          }}>
            
            {(videoUrl || fullVideoUrl) ? (
              <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                <iframe
                  src={`https://www.youtube.com/embed/${(videoUrl || fullVideoUrl).match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/|youtube\.com\/shorts\/)([^"&?\/\s]{11})/)?.[1] || ''}?autoplay=1`}
                  title="Player Preview"
                  style={{ width: '100%', height: '100%', border: 'none', objectFit: 'cover' }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            ) : (
              <>
                {previewThumb ? (
                  <img src={previewThumb} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="Preview" />
                ) : (
                  <ImageIcon color="#222" size={40} style={{ marginTop: aspectMode === '16:9' ? '25%' : '50%' }} />
                )}
                <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: 10, background: 'linear-gradient(transparent, #000)', boxSizing: 'border-box' }}>
                  <p style={{ color: '#fff', fontSize: 10, textAlign: 'left', fontWeight: 'bold', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title || 'Título Aqui'}</p>
                  <p style={{ color: '#ff0000', fontSize: 8, textAlign: 'left', margin: '2px 0 0 0' }}>{category.split(':')[1] || category}</p>
                </div>
              </>
            )}

          </div>
        </aside>
      </div>
    </div>
  );
}